// extracted by mini-css-extract-plugin
export default {"VariantsTable":"VariantsTable_VariantsTable__+uG8w","dropzone":"VariantsTable_dropzone__Iupef","container":"VariantsTable_container__LQgfL"};